export default __webpack_public_path__ + "static/media/photo--sm--121.9985703d.jpg";